// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"141":"component---node-modules-gatsby-theme-apollo-core-src-pages-404-js","900":"component---node-modules-gatsby-theme-apollo-docs-src-components-template-js"}[chunkId] + "-" + {"141":"b342523601e9bccb0383","900":"b583b79deadaeee6b14a"}[chunkId] + ".js";
};